import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

export const MeetingCardSkeleton = () => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-6 w-3/4" />
            <div className="flex items-center gap-4">
              <Skeleton className="h-4 w-[120px]" />
              <Skeleton className="h-4 w-[100px]" />
            </div>
          </div>
          <Skeleton className="h-6 w-6 rounded-md" />
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-[180px]" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-4 rounded-full" />
            <Skeleton className="h-4 w-[140px]" />
          </div>
          <div className="flex gap-2 mt-4">
            <Skeleton className="h-8 w-[100px] rounded-md" />
            <Skeleton className="h-8 w-[100px] rounded-md" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const MeetingListSkeleton = ({ count = 3 }: { count?: number }) => {
  return (
    <div className="space-y-4">
      {[...Array(count)].map((_, i) => (
        <MeetingCardSkeleton key={i} />
      ))}
    </div>
  );
};

export const MeetingTableSkeleton = ({ rows = 5 }: { rows?: number }) => {
  return (
    <div className="space-y-3">
      {/* Header */}
      <div className="flex items-center justify-between border-b pb-3">
        <div className="flex gap-6">
          <Skeleton className="h-4 w-[120px]" />
          <Skeleton className="h-4 w-[100px]" />
          <Skeleton className="h-4 w-[80px]" />
          <Skeleton className="h-4 w-[100px]" />
        </div>
        <Skeleton className="h-4 w-[80px]" />
      </div>

      {/* Rows */}
      {[...Array(rows)].map((_, i) => (
        <div key={i} className="flex items-center justify-between py-3 border-b">
          <div className="flex gap-6">
            <Skeleton className="h-5 w-[150px]" />
            <Skeleton className="h-5 w-[100px]" />
            <Skeleton className="h-5 w-[80px]" />
            <Skeleton className="h-5 w-[120px]" />
          </div>
          <Skeleton className="h-8 w-[80px] rounded-md" />
        </div>
      ))}
    </div>
  );
};
